import * as React from "react";
import { cn } from "../../lib/utils";
import { NumberInput, type NumberInputProps } from "./numberInput";

const Input = React.forwardRef<HTMLInputElement, NumberInputProps>(({ className, type, ...props }, ref) => {
  // NumberInput is a plain <input> except for a controlled number box, which
  // it lets be emptied and shows without a resting 0 (see numberInput.tsx).
  return (
    <NumberInput
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive h-[35px] bg-[#fcfcfc] border-[#cdd1d0] rounded-[12px] focus:ring-1 focus:ring-primary",
        className
      )}
      {...props}
    />
  );
});
Input.displayName = "Input";

export { Input };
